<template>
    <div style="font-size: 15px;">
        <div class="law-aiask-result-source-hide" v-html="currentText"></div>
        <div class="law-aiask-result-output-hide "></div>
        <div class="law-aiask-result-stopGenerate"><span @click="stop">
            <svg-icon class="stop-icon" icon-class="stop"></svg-icon>停止生成</span>
        </div>
    </div>
</template>
<script>
class Typing {
    constructor(opts) {
        this.opts = opts || {};
        this.source = opts.source;
        this.output = opts.output;
        this.delay = opts.delay || 0;
        this.isStop = false
        this.chain = {
            parent: null,
            dom: this.output,
            val: []
        };
        this.scrollCon = opts.scrollCon
        if (!(typeof this.opts.done === 'function')) this.opts.done = function () {};
    }
    init() {
        //初始化函数
        this.chain.val = this.convert(this.source, this.chain.val);
    }
    convert(dom, arr) {
        //将dom节点的子节点转换成数组，
        let children = Array.from(dom.childNodes)
        for (let i = 0; i < children.length; i++) {
            let node = children[i]
            if (node.nodeType === 3) {
                arr = arr.concat(node.nodeValue.split(''))   //将字符串转换成字符串数组，后面打印时才会一个一个的打印
            } else if (node.nodeType === 1) {
                let val = []
                val = this.convert(node, val)
                arr.push({'dom': node,'val': val})
            }
            }
            return arr
        }
    print(dom, val, callback) {
        setTimeout(function () {
            dom.appendChild(document.createTextNode(val));
            
            callback();
        }, this.delay);
    }
    play(ele) {
        //当打印最后一个字符时，动画完毕，执行done
        if (this.isStop) return
        if (!ele.val.length) {
            if (ele.parent) this.play(ele.parent);
            else {
                this.opts.done();
            }
            return;
        }
        let current = ele.val.shift()  //获取第一个元素，同时删除数组中的第一个元素
        if (typeof current === 'string') {
            this.addCursor(ele.dom)
            Typing.throttle(Typing.scrollToBottom(this.scrollCon), 1000)
            this.print(ele.dom, current, () => {
                this.play(ele); //继续打印下一个字符
            })
        } else {
            let dom = current.dom.cloneNode() //克隆节点，不克隆节点的子节点，所以不用加参数true 
            ele.dom.appendChild(dom)
            this.addCursor(dom)
            Typing.throttle(Typing.scrollToBottom(this.scrollCon), 1000)
            this.play({parent: ele,dom,val: current.val})
        }
    }
    addCursor(dom) {
        this.removeAllCursor()
        dom.classList.add('law-aiask-result-output-blink')
    }
    removeAllCursor() {
        Array.from(document.querySelectorAll('.law-aiask-result-output-blink')).forEach(item => item.classList.remove('law-aiask-result-output-blink'))
    }
    start() {
        this.init();
        this.play(this.chain);
    }
    stop() {
    	this.isStop = false
    }
}
// 先写个简单的用
Typing.scrollToBottom = function(scrollCon) {
    const wrapper = document.querySelector(scrollCon);
    (function smoothscroll() {
    const currentScroll = wrapper.scrollTop;   
    const clientHeight = wrapper.offsetHeight; 
    const scrollHeight = wrapper.scrollHeight; 
    if (scrollHeight - 10 > currentScroll + clientHeight) {
        window.requestAnimationFrame(smoothscroll);
        wrapper.scrollTo(0, currentScroll + (scrollHeight - currentScroll - clientHeight) / 2);
    }
    })();
}
// 节流函数
Typing.throttle = function(func, wait) {
    let _this, args, timeout;
    return function () {
      _this = this;
      args = arguments;
  
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          func.apply(_this, args);
        }, wait)
      }
    }
}
export default {
    props: {
        scrollCon: {
            type: String,
            default: 'body'
        }
    },
    data() {
        return {
            currentTextArr: [], //分次返回的数据
            currentText:'', // 当前正在打印中的文本
            isTyping: false, // 是否正在打印中
            isFinish: false, // 数据是否传输完毕
            isDone: false, // 是否全部打印完成
            receiveStr: '',  //  当前接收到的总的字符串
            instance: null
        }
    },
    watch: {
        canTyping(newVal, oldVal) {
            if (newVal && !this.isStop) {
                this.typeAnswer()
            }
        }
    },
    computed: {
      // 通过 正在打印和当前数组中是否有值两个变量确定是否调用
        canTyping() {
            return !this.isTyping && this.currentTextArr.length > 0
        }
    },
    methods: {
        typeAnswer() {
            let source = document.querySelector('.law-aiask-result-source-hide')
            let output = document.querySelector('.law-aiask-result-output-hide')
            let text = this.currentTextArr.shift()
            this.currentText = text
            source.innerHTML = text
            this.instance = new Typing({
                source, 
                output, 
                scrollCon: this.scrollCon, 
                done: () => {
                this.isTyping = false
                if (this.isFinish == true && this.currentTextArr.length <= 0) {
                // 数据传输完毕,打印完毕
                    this.closingWork()
                }
            }})
            this.isTyping = true
            this.instance.start()
        },
        resetData() {
            this.currentTextArr = []
            this.currentText = ''
            this.isTyping = false
            this.isFinish = false
            this.isDone = false
            this.receiveStr = '' 
            this.isStop = false
            document.querySelector('.law-aiask-result-source-hide').innerHTML = ''
            document.querySelector('.law-aiask-result-output-hide').innerHTML = ''
        },
        initTypingData() {
            this.resetData()
            // 增加开始请求数据时出现光标等待效果
            this.currentTextArr.push(('<span class="law-aiask-result-output-waiting" style="padding:0;margin:0;"></span>'))
            Typing.scrollToBottom(this.scrollCon)
        },
        // 收尾工作
        closingWork() {
            // 可以传入返回值,这种种情况不会抛出打印的值
            this.isDone = true
            this.instance && this.instance.removeAllCursor();
            let typingDom = document.querySelector('.law-aiask-result-output-hide');
            let waitingDom = typingDom.querySelector('.law-aiask-result-output-waiting')
            
            waitingDom && waitingDom.remove()
            this.$emit('doneTyping', typingDom.innerHTML)
            typingDom.innerHTML = ''
            this.instance && (this.instance = null)
            // this.resetData()
        },
        // 停止生成 
        stop() {
        	this.isStop = true
            this.instance && (this.instance.isStop = true)
            this.closingWork()
        }
    }
}
</script>

<style >
.law-aiask-result-reGenerate, .law-aiask-result-stopGenerate{
  color: #4955f5;
  cursor: pointer;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.law-aiask-result-source-hide{
   width: 0;
   height: 0;
   padding: 0;
   margin: 0;
   overflow: hidden;
   font-size :15px;
}
.stop-icon{
    vertical-align: top;
    margin-right: 3px;
    margin-top: 1px;
    /* color: #ccc; */
    /* color:; */
}
.law-aiask-result-output-blink::after{
    display: inline-block;
    -webkit-animation: blink 1s steps(5,start) infinite;
    animation: blink 1s steps(5,start) infinite;
    content: "▎";
    font-size: inherit;
    font-style: normal;
    /* left: 23px; */
    /* position: absolute; */
    /* top: 50%; */
    /* transform: translateY(-50%) scaleX(.7); */
    vertical-align: middle
}
@-webkit-keyframes blink {
  to {
    visibility: hidden
  }
}

@keyframes blink {
  to {
    visibility: hidden
  }
}
</style>